import React from 'react';
import { CtaButton } from '../CtaButton';
import { SectionHeading } from '../SectionHeading';
import { promises } from '../../data/content';
export function ValueProps() {
  return <section className="bg-paper-50 px-5 py-14 sm:px-8 sm:py-20" data-id="element-298" data-mp="1cjijgrlls47p">
      <div className="mx-auto max-w-4xl" data-id="element-299" data-mp="1ck1zg2rp0ij3">
        <SectionHeading tone="light" title="Know Exactly What to Do When a TRT Case Walks Into Your Office" data-id="element-300" data-mp="18iourw0c6ldr" />

        <div className="mx-auto mt-6 max-w-2xl space-y-1.5 text-center text-[15px] font-semibold text-ink-600 sm:text-lg" data-id="element-301" data-mp="257xwj8l6ccge">
          <p data-id="element-302" data-mp="20bfrs8puge42">You don’t need another 20-hour course.</p>
          <p data-id="element-303" data-mp="1vhl3erzanayn">You don’t need another pile of disconnected research papers.</p>
          <p className="text-ink-900" data-id="element-304" data-mp="1rhknt40gktq0">
            You need a clear clinical system that helps you move from patient evaluation to
            treatment and long-term monitoring.
          </p>
        </div>

        <p className="mx-auto mt-6 max-w-2xl text-center text-[15px] text-ink-600 sm:text-base" data-id="element-305" data-mp="2j7ywmltm7fut">
          With the Master System of TRT™, you’ll have a structured reference designed to help you:
        </p>

        <ol className="mt-8 space-y-4" data-id="element-306" data-mp="3h7uhjl7hclyx">
          {promises.map((item, i) => <li key={item.title} className="flex gap-3 rounded-2xl border border-paper-200 bg-white p-4 sm:gap-4 sm:p-6" data-id="element-307" data-mp="32kj6rlj4h5zv" data-mpi={i}>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-ink-900 font-display text-base font-bold text-teal-300 sm:h-10 sm:w-10 sm:text-lg" data-id="element-308" data-mp="37gzxmnhphygn">
                {i + 1}
              </span>
              <div className="min-w-0" data-id="element-309" data-mp="2jldl0i6kmce8">
                <h3 className="text-[15px] font-extrabold leading-snug text-ink-900 sm:text-lg" data-id="element-310" data-mp="2jmf8jm4rwrcu">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-sm leading-relaxed text-ink-600 sm:text-base" data-id="element-311" data-mp="htr2l50qvptd">
                  {item.body}
                </p>
              </div>
            </li>)}
        </ol>

        <div className="mx-auto mt-10 max-w-md" data-id="element-312" data-mp="lbolkqijyz96">
          <CtaButton label="Get the Master System of TRT™" subLabel="Instant Access · One-Time Payment · USD 27" data-id="element-313" data-mp="lchhsxjvy6d2" />
        </div>
      </div>
    </section>;
}